import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useScrollToHash } from "@/hooks/useScrollToHash";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesSection from "./components/ServicesSection";
import ListingsSection from "./components/ListingsSection";
import ProcessSection from "./components/ProcessSection";
import RenovationStoriesSection from "./components/RenovationStoriesSection";
import HonestFAQSection from "./components/HonestFAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  useScrollToHash();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />

        <div className="w-full h-24 md:h-32 bg-paper relative overflow-hidden">
          <div
            className="absolute inset-0 opacity-[0.04]"
            style={{
              backgroundImage:
                "url('https://readdy.ai/api/search-image?query=Sumi%20ink%20wash%20on%20rice%20paper%20single%20soft%20gradient%20stroke%20from%20dark%20to%20light%20muted%20minimal%20Japanese%20calligraphy%20style%20texture%20seamless%20no%20text%20no%20objects&width=1200&height=300&seq=noren-divider-sumi&orientation=landscape')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>
        </div>

        <ListingsSection />

        <section className="w-full bg-paper-secondary py-16 md:py-20">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
              <div className="max-w-xl">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-3">
                  {t("coPromo.sectionLabel")}
                </p>
                <h2 className="font-serif text-2xl md:text-3xl text-ink leading-tight mb-3">
                  {t("coPromo.title")}
                  <br />
                  <span className="italic font-normal text-ink/60">{t("coPromo.titleItalic")}</span>
                </h2>
                <p className="text-sm text-ink/50 leading-relaxed mb-5">
                  {t("coPromo.body")}
                </p>
                <Link
                  to="/co-ownership"
                  className="inline-flex items-center gap-2 bg-ink text-paper text-sm font-medium px-6 py-3 rounded-full hover:bg-indigo transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  {t("btn.explore")}
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </Link>
              </div>

              <div className="w-full lg:w-80 bg-white border border-hairline p-5">
                <p className="text-xs text-ink/30 uppercase tracking-wider mb-2">{t("coPromo.example")}</p>
                <p className="font-serif text-lg text-ink mb-1">{t("coPromo.exampleTitle")}</p>
                <div className="flex items-baseline gap-2 mb-3">
                  <span className="font-serif text-xl font-semibold text-ink">¥8.5M</span>
                  <span className="text-sm text-ink/40">{t("label.allIn")}</span>
                </div>
                <div className="h-1.5 bg-paper-secondary rounded-full overflow-hidden mb-2">
                  <div className="h-full bg-[#3F6F4F] rounded-full w-1/2"></div>
                </div>
                <div className="flex items-center justify-between text-xs text-ink/40 mb-4">
                  <span>{t("coPromo.exampleProgress")}</span>
                  <span className="text-vermilion font-medium">{t("coPromo.exampleSpots")}</span>
                </div>
                <div className="border-t border-hairline pt-3">
                  <p className="text-xs text-ink/40">
                    {t("label.approx")} <span className="font-semibold text-ink">¥2.1M</span> {t("label.perShare")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <ProcessSection />
        <RenovationStoriesSection />
        <HonestFAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}